<!-- Modals -->
<app-deprecated-modal-form
    #reviewDetailsModal
    [form]="reviewDetailsForm"
    (save)="onSaveAction()"
    (cancel)="onCancel()"
    *ngIf="canEditThisReview"
    headerText="performance.show.editReview"
    [hideOnSave]="false"
>
    <app-form-review-details
        #reviewDetailsForm
        [review]="review"
        [performanceReviewImprovements]="hasPerformanceReviewImprovementsFeatureFlag"
    ></app-form-review-details>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDelete
    title="performance.show.deleteReview"
    description="performance.show.deleteReviewConfirmation"
    label="performance.show.delete"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-common-bulk-select-employee-dialog
    #appEmployeeSelection
    *ngIf="canEditThisReview"
    label="performance.show.assign"
></app-common-bulk-select-employee-dialog>

<app-review-display
    #reviewDisplayComponent
    *ngIf="review.userAssignment"
    [fields]="review.userAssignment.jsonData"
    [response]="review.userResponse"
    [review]="review"
    [performanceReviewImprovements]="hasPerformanceReviewImprovementsFeatureFlag"
    (saved)="onResponseSave($event)"
></app-review-display>

<app-deprecated-confirmation-dialog
    #confirmAccessChange
    title="performance.show.changeAccessPermissions"
    description="performance.show.changeAccessPermissionsDescription"
    label="performance.show.confirm"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<app-review-results
    #reviewResultsComponent
    [review]="review"
    [canExportResults]="canExportResults"
    [performanceReviewImprovements]="hasPerformanceReviewImprovementsFeatureFlag"
></app-review-results>

<ui-confirmation-dialog
    #confirmForceComplete
    header="performance.show.forceCompleteReviewConfirmationHeader"
    primaryButtonLabel="confirm"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    {{ 'performance.show.forceCompleteReviewConfirmationText' | translate }}
</ui-confirmation-dialog>

<!-- Body -->
<div class="ui narrow segment basic" [class.loading]="isLoading">
    <app-header [title]="review.title" [back]="true" [contextMenu]="canEditThisReview" contextMenuType="material">
        <div class="buttons" *ngIf="hasPerformanceReviewImprovementsFeatureFlag">
            <ui-button (click)="results()" *ngIf="canViewResults" type="primary">
                {{ 'performance.show.viewResults' | translate }}
            </ui-button>

            <ui-button
                *ngIf="hasPerformanceReviewImprovementsFeatureFlag && canCompleteReview"
                (click)="launch()"
                type="primary"
                [disabled]="!review.isReady"
                >{{ 'performance.show.completeReview' | translate }}
            </ui-button>

            <ui-button (click)="results(loggedInEmployee)" *ngIf="canViewOwnResponses" type="primary"
                >{{ 'performance.show.viewMyResponse' | translate }}
            </ui-button>
        </div>
        <button mat-menu-item (click)="onEdit()">{{ 'edit' | translate }}</button>
        <button mat-menu-item *ngIf="!review.isComplete" (click)="remind()">
            {{ 'performance.show.remindParticipants' | translate }}
        </button>
        <button mat-menu-item *ngIf="!review.isComplete" (click)="forceComplete()">
            {{ 'performance.show.forceComplete' | translate }}
        </button>
        <button mat-menu-item (click)="onDelete()">{{ 'delete' | translate }}</button>
    </app-header>

    <div class="ui segment">
        <div class="reviewStatus">
            <ng-container *ngIf="review.statusId === Status.Completed">
                <span class="ui tiny circular empty green label"></span> {{ 'performance.show.completed' | translate }}
            </ng-container>
            <ng-container *ngIf="review.statusId === Status.InProgress">
                <span class="ui tiny circular empty yellow label"></span>
                {{ 'performance.show.inProgress' | translate }}
            </ng-container>
            <ng-container *ngIf="review.statusId === Status.Missed">
                <span class="ui tiny circular empty orange label"></span> {{ 'performance.show.missed' | translate }}
            </ng-container>
            <ng-container *ngIf="review.statusId === Status.Overdue">
                <span class="ui tiny circular empty red label"></span> {{ 'performance.show.overdue' | translate }}
            </ng-container>
        </div>
        <app-segment-header title="performance.reviewDetails"></app-segment-header>

        <form class="ui static form">
            <ui-banner *ngIf="!hasPerformanceReviewImprovementsFeatureFlag" class="padding-bottom-4" variant="info">
                {{ responseAccessMessage }}
            </ui-banner>

            <div class="inline field">
                <label>{{ 'performance.show.reviewee' | translate }}</label>
                {{ review.subject?.firstName }} {{ review.subject?.lastName }}
            </div>

            <div class="inline field">
                <label>{{ 'performance.show.template' | translate }}</label>
                {{ review.template?.name }}
            </div>

            <div *ngIf="review.reoccuring !== 'never'" class="inline field">
                <label>{{ 'performance.show.frequency' | translate }}</label>
                {{ review.reoccuring }}
            </div>

            <div *ngIf="hasPerformanceReviewImprovementsFeatureFlag" class="inline field">
                <label>{{ 'performance.show.reviewPeriod' | translate }}</label>
                {{ review.periodStart | appDate: 'mediumDate' }} - {{ review.periodEnd | appDate: 'mediumDate' }}
            </div>

            <div class="inline field">
                <label>{{ 'performance.show.startDate' | translate }}</label>
                {{ review.scheduleAt | appDate: 'mediumDate' }}
            </div>

            <div class="inline field">
                <label>{{ 'performance.show.dueDate' | translate }}</label>
                {{ review.dueAt | appDate: 'mediumDate' }}
            </div>

            <div *ngIf="hasPerformanceReviewImprovementsFeatureFlag" class="inline field">
                <label>{{ 'performance.show.createdBy' | translate }}</label>
                {{ review.creator?.firstName }} {{ review.creator?.lastName }}
            </div>

            <div *ngIf="hasPerformanceReviewImprovementsFeatureFlag" class="field">
                <label>{{ 'performance.show.description' | translate }}</label>
                <p class="margin-bottom-0" [innerHTML]="review.instruction | nl2br | sanitizeHtml"></p>
            </div>

            <ui-button
                *ngIf="!hasPerformanceReviewImprovementsFeatureFlag && canCompleteReview"
                (click)="launch()"
                style="display: block; width: 150px; margin: 0 auto"
                type="primary"
                [disabled]="!review.isReady"
                >{{ 'performance.show.completeReview' | translate }}
            </ui-button>

            <ui-button
                (click)="results()"
                type="primary"
                style="display: block; width: 150px; margin: 0 auto"
                *ngIf="review.isComplete && canViewResults && !hasPerformanceReviewImprovementsFeatureFlag"
            >
                {{ 'performance.show.viewResults' | translate }}
            </ui-button>
        </form>
    </div>

    <app-review-note *ngIf="showReviewNoteSection" [review]="review" class="d-block margin-bottom-3"></app-review-note>

    <div class="ui table segment">
        <app-segment-header title="performance.show.participants" (edit)="onAssign()" [allowEdit]="canEditThisReview">
        </app-segment-header>
        <table class="ui unstackable table">
            <tbody>
                <tr *ngFor="let assignment of review.assignments">
                    <td class="collapsing">
                        <app-avatar *ngIf="assignment?.employee" [employee]="assignment.employee"></app-avatar>
                    </td>
                    <td>{{ assignment?.employee?.firstName }} {{ assignment?.employee?.lastName }}</td>
                    <td class="right aligned">
                        <!--If the review is in the future, show that it is scheduled -->
                        <ng-container *ngIf="review.statusId === Status.Scheduled">
                            <span class="ui tiny circular empty blue label"></span>
                            {{ 'performance.show.scheduled' | translate }}
                        </ng-container>

                        <!--If the review is not in the future, show the individual status-->
                        <ng-container *ngIf="review.statusId !== Status.Scheduled">
                            <ng-container *ngIf="assignment.response?.submittedAt">
                                <span class="ui tiny circular empty green label"></span>
                                {{ 'performance.show.completed' | translate }}
                            </ng-container>
                            <ng-container *ngIf="!assignment.response?.submittedAt">
                                <span class="ui tiny circular empty yellow label"></span>
                                {{ 'performance.show.inProgress' | translate }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="ui segment" *ngIf="hasPerformanceReviewImprovementsFeatureFlag">
        <app-segment-header title="performance.show.responsesAccess"></app-segment-header>

        <div class="margin-bottom-2">
            <strong>{{ 'performance.show.admins' | translate }}</strong>
        </div>
        <div class="margin-bottom-2">
            <p>{{ 'performance.show.adminsCanAlwaysSeeResponses' | translate }}</p>
        </div>

        <div class="margin-bottom-2">
            <strong>{{ 'performance.show.directManagers' | translate }}</strong>
            <ui-info
                class="margin-left-1"
                text="performance.bulk-review.responseAccess.directManagerSettingTooltip"
            ></ui-info>
        </div>
        <div class="margin-bottom-2">
            <p *ngIf="!review.viewResultsBeforeCompletion">
                {{ 'performance.show.canAlwaysSeeResponsesCompleted' | translate }}
            </p>
            <p *ngIf="review.viewResultsBeforeCompletion">
                {{ 'performance.show.directManagersCanAlwaysSeeResponses' | translate }}
            </p>
        </div>

        <div *ngIf="review.subjectCanViewResults || review.participantsCanViewResults" class="margin-bottom-2">
            <strong>{{ 'performance.show.reviewAndOtherReviewParticipants' | translate }}</strong>
        </div>
        <div class="margin-bottom-2">
            <p *ngIf="review.subjectCanViewResults">{{ 'performance.show.resultVisibleToRevieweeSelf' | translate }}</p>
            <p *ngIf="review.participantsCanViewResults">
                {{ 'performance.show.resultVisibleToOtherParticipants' | translate }}
            </p>
        </div>
    </div>

    <div class="ui table segment" *ngIf="!hasPerformanceReviewImprovementsFeatureFlag">
        <app-segment-header title="performance.show.createdBy"></app-segment-header>
        <table *ngIf="review.creator" class="ui unstackable table">
            <tbody>
                <tr>
                    <td class="collapsing">
                        <app-avatar *ngIf="review.creator" [employee]="review.creator"></app-avatar>
                    </td>
                    <td>{{ review?.creator?.firstName }} {{ review?.creator?.lastName }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
